import * as React from "react";
import "./content-header.scss";
import {SearchInput} from "../../../../../../common/design2/search-input/search-input";

export const ContentHeader = ({search}) => (
    <div className="header content-header-3dd">
        <div className="left">
            <div className="title" xd-qa-type="label" xd-qa-name="Coop Condo List Build Address List" >
                Build Address List
            </div>
            <div className="sub-title" xd-qa-type="label" xd-qa-name="Coop Condo List Subtitle">
                If the addresses appear to be correct, select "Next".
            </div>
        </div>
        <div className="right">
            {SearchInput({
                state: search,
                placeholder: "Search List",
                // text: filter.value && <>Found <b>{filteredRecords.length}</b> {plural("address", filteredRecords.length)}</>,
                xdQaName: "Coop Condo List Search",
            })}
        </div>
    </div>
);
